import Head from "next/head";

import { useContext } from "react";

import ChangePlan from "@components/membership/ChangePlan";
import FollowedCases from "components/FollowedCases";
import Footer from "components/footer";
import GetStarted from "components/GetStarted";
import Header from "@components/header";
import MemberPerks from "components/MemberPerks";
import { useEffect, useState } from "react";
import { useUser } from "@auth0/nextjs-auth0/client";
import { useRouter } from "next/router";

import { OutsetaContext } from "pages/_app";

import CaseUpdates from "components/CaseUpdates";

export default function Workspace() {
  const [showFollowedCases, setShowFollowedCases] = useState(false);
  const [showCaseUpdates, setShowCaseUpdates] = useState(false);
  const { user, isLoading } = useUser();
  const router = useRouter();

  const {
    outsetaUserCaseList,
    outsetaFirstName,
    outsetaUserPlanType,
    isOutsetaLoading,
    isPaidSubscriber,
  } = useContext(OutsetaContext);

  useEffect(() => {
    if (outsetaUserCaseList !== "") {
      setShowFollowedCases(true);
      setShowCaseUpdates(true);
    }
  }, [outsetaUserCaseList]);

  return (
    <>
      <Head>
        <title>My Workspace</title>
      </Head>
      <Header />
      <main className="bg-gray-50 min-h-screen pt-6 pb-16">
        {!user ? (
          <>
            {isLoading ? (
              <>
                <div className="flex justify-center items-center">
                  <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
                </div>
              </>
            ) : (
              <>
                <section className="bg-white max-w-6xl mx-4 p-6 shadow-md flex flex-col lg:items-center lg:justify-between lg:mx-auto">
                  <p
                    className={`font-semibold mx-auto mt-4 text-xl text-center w-72 sm:max-w-lg sm:text-4xl sm:w-full`}
                  >
                    Login to access your workspace and profile.
                  </p>
                  <a
                    href={
                      router.query?.showOutseta === "true"
                        ? "/api/auth/login?returnTo=%2Fprofiles%2Fworkspace%3FshowOutseta%3Dtrue"
                        : "/api/auth/login"
                    }
                  >
                    <button className="mx-1 mt-12 px-12 uppercase bg-yellow-400 border-yellow-400 text-white hover:bg-yellow-500 hover:border-yellow-500 py-2.5 text-sm">
                      Login
                    </button>
                  </a>
                </section>
              </>
            )}
          </>
        ) : (
          <>
            <section className="bg-white max-w-6xl mx-4 p-6 shadow-md flex flex-col lg:flex-row lg:items-center lg:justify-between lg:mx-auto">
              <p className="flex flex-col lg:flex-row font-semibold items-center">
                <span>
                  Welcome back
                  <span className="outseta-name">{outsetaFirstName}</span>!
                </span>
                <span className="bg-grqy-200 flex font-semibold items-center lg:ml-6 px-2 py-1 rounded text-xs text-black">
                  {outsetaUserPlanType}
                </span>
              </p>
              <ChangePlan>Account Settings</ChangePlan>
            </section>

            <section className="max-w-6xl mx-auto px-4 pt-6 lg:flex lg:items-start xl:px-0">
              <aside className="max-w-sm lg:pr-8 lg:flex-shrink-0">
                {!isOutsetaLoading && !isPaidSubscriber && <MemberPerks />}
                {showCaseUpdates && (
                  <CaseUpdates outsetaUserCaseList={outsetaUserCaseList} />
                )}
              </aside>

              <div className="lg:flex-grow">
                {/* For when we make the full change to membership being paid */}
                {/* {outsetaUserPlanId !== "" && outsetaUserPlanId === "rm064J9X" && ( */}
                {!isOutsetaLoading && (
                  <GetStarted outsetaUserCaseList={outsetaUserCaseList} />
                )}
                {showFollowedCases && (
                  <FollowedCases outsetaUserCaseList={outsetaUserCaseList} />
                )}
              </div>
            </section>
          </>
        )}
      </main>
      <Footer />
    </>
  );
}
